// Stored messages may contain HTML or entity-encoded HTML. Decode in an inert
// template, stopping as soon as markup exists so video attributes stay intact.
export function decodeCommbookHtml(value) {
    var html = typeof value === 'string' ? value : '';
    for (var pass = 0; pass < 2; pass += 1) {
        var template = document.createElement('template');
        template.innerHTML = html;
        if (template.content.children.length ||
            !/&(?:lt|gt|amp|quot|nbsp|#\d+|#x[\da-f]+);/i.test(html)) {
            break;
        }
        html = template.content.textContent || '';
    }
    return html;
}
function isPersistentMediaUrl(value) {
    if (!value || !value.trim())
        return false;
    try {
        var url = new URL(value.trim(), window.location.origin);
        return url.protocol === 'http:' || url.protocol === 'https:';
    }
    catch (error) {
        return false;
    }
}
export function getCommbookContent(value) {
    var html = decodeCommbookHtml(value);
    var template = document.createElement('template');
    template.innerHTML = html;
    var text = '';
    var blocks = new Set(['p', 'div', 'li', 'tr', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6']);
    var visit = function (node) {
        if (node.nodeType === Node.TEXT_NODE) {
            text += node.textContent || '';
            return;
        }
        if (node.nodeType !== Node.ELEMENT_NODE)
            return;
        var element = node;
        var tag = element.tagName.toLowerCase();
        if (['script', 'style', 'template', 'video', 'source', 'img'].includes(tag))
            return;
        if (tag === 'br') {
            text += '\n';
            return;
        }
        if (blocks.has(tag) && text && !text.endsWith('\n'))
            text += '\n';
        Array.from(element.childNodes).forEach(visit);
    };
    Array.from(template.content.childNodes).forEach(visit);
    var characterCount = 0;
    for (var _i = 0, text_1 = text; _i < text_1.length; _i++) {
        var character = text_1[_i];
        var code = character.codePointAt(0) || 0;
        characterCount +=
            (code >= 0x3400 && code <= 0x9fff) ||
                (code >= 0xf900 && code <= 0xfaff) ||
                (code >= 0x20000 && code <= 0x2fa1ff) ||
                (code >= 0xff01 && code <= 0xff60) ||
                (code >= 0xffe0 && code <= 0xffe6)
                ? 2
                : 1;
    }
    var media = Array.from(template.content.querySelectorAll('img, video, video source'));
    var hasInvalidMedia = media.some(function (element) {
        return ['src', 'poster'].some(function (attribute) {
            var source = element.getAttribute(attribute);
            return Boolean(source && !isPersistentMediaUrl(source));
        });
    });
    var hasMedia = media.some(function (element) {
        if (element.tagName.toLowerCase() === 'source')
            return false;
        if (isPersistentMediaUrl(element.getAttribute('src')))
            return true;
        return (element.tagName.toLowerCase() === 'video' &&
            Array.from(element.querySelectorAll('source')).some(function (source) {
                return isPersistentMediaUrl(source.getAttribute('src'));
            }));
    });
    return {
        html: html,
        text: text,
        characterCount: characterCount,
        hasContent: Boolean(text.trim()) || hasMedia,
        hasInvalidMedia: hasInvalidMedia
    };
}
export function validCommbookContent(value, attachments) {
    if (attachments === void 0) { attachments = []; }
    var content = getCommbookContent(value);
    return (content.characterCount <= 4000 &&
        !content.hasInvalidMedia &&
        (content.hasContent || attachments.length > 0));
}
